var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.02128 18 0 13.9787 0 9C0 4.02128 4.02128 0 9 0C13.9787 0 18 4.02128 18 9C18 13.9787 13.9787 18 9 18ZM9 1.49362C4.86383 1.49362 1.49362 4.86383 1.49362 9C1.49362 13.1362 4.86383 16.5064 9 16.5064C13.1362 16.5064 16.5064 13.1362 16.5064 9C16.5064 4.86383 13.1362 1.49362 9 1.49362Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7958 5.89789C12.2936 6.31917 12.5234 6.97023 12.5234 7.85108C12.5234 8.73193 12.2553 9.3447 11.7575 9.76597C11.2596 10.1873 10.4553 10.3787 9.4213 10.3787H8.46386V12.7532C8.46386 13.1745 8.11918 13.5575 7.6596 13.5575C7.23833 13.5575 6.85535 13.2128 6.85535 12.7532V5.97449C6.85535 5.55321 7.20003 5.24683 7.58301 5.24683H9.34471C10.5319 5.24683 11.3362 5.47661 11.7958 5.89789ZM10.6468 8.65534C10.8383 8.42555 10.9149 8.11917 10.9149 7.73619C10.9149 7.35321 10.8 7.04683 10.5319 6.85534C10.3022 6.70215 9.91918 6.58725 9.38301 6.58725H8.46386V9.00002H9.5362C10.1107 9.00002 10.4553 8.88512 10.6468 8.65534Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.c5c1251f7b3c97dc53b94d1698ba937e.svg";
export { ForwardRef as ReactComponent };